type TGameCategory = {
  tag: string | null;
  actionData?: unknown;
};

export function isGameExistInHeader(categories: TGameCategory[], gameId: string) {
  return categories.some((category) => category.actionData === gameId && category.tag === "header");
}
